import { useMutation } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgCategory } from "../../../generated/core-api";
import { useOrgMutationSuccess } from "./useOrgMutationSuccess";

/**
 * Hook for updating an organization's name
 */
export function useUpdateOrgName() {
  const onSuccess = useOrgMutationSuccess(OrgCategory.public);

  return useMutation({
    mutationFn: async ({
      category,
      orgId,
      name,
    }: {
      category: OrgCategory;
      orgId: string;
      name: string;
    }) => {
      return await api.updateOrgName(category, orgId, { name });
    },
    onSuccess,
  });
}
